const consoleLog = (title?: string, content?: any) => {
  if (process.env.NODE_ENV === "development") {
    console.log(title || "no title", content || "no content");
  }
};

export default consoleLog;
